import { get, post, put, del } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class RoleService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const companyId = getCompanyId();
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      companyId,
      sortMode: 'split',
    });

    return await get(`/role?${queryParams.toString()}`);
  }

  static async create(payload) {
    const companyId = getCompanyId();
    const { accesses = [], ...rolePayload } = payload || {};
    const roleData = {
      ...rolePayload,
      companyId: companyId
    };
    const createdRole = await post('/role', roleData);
    if (createdRole?.id && Array.isArray(accesses) && accesses.length > 0) {
      await this.updateAccesses(createdRole.id, accesses);
    }
    return createdRole;
  }

  static async update(roleId, payload) {
    const companyId = getCompanyId();
    const { accesses = [], ...rolePayload } = payload || {};
    const roleData = {
      ...rolePayload,
      companyId: companyId
    };
    const updatedRole = await put(`/role/${roleId}`, roleData);
    if (Array.isArray(accesses)) {
      await this.updateAccesses(roleId, accesses);
    }
    return updatedRole;
  }

  static async delete(roleId) {
    return await del(`/role/${roleId}`);
  }

  static async updateEnabled(roleId, payload) {
    const companyId = getCompanyId();
    const roleData = {
      ...payload,
      companyId: companyId
    };
    return await put(`/role/enabled/${roleId}`, roleData);
  }

  static async getAccessCatalog() {
    return await get('/role/accesses/catalog');
  }

  static async getAccesses(roleId) {
    return await get(`/role/${roleId}/accesses`);
  }

  static async updateAccesses(roleId, accesses = []) {
    return await put(`/role/${roleId}/accesses`, accesses);
  }
}

export default RoleService;

